import { createSlice, createAsyncThunk, isAllOf } from '@reduxjs/toolkit'

// ** Axios Imports
import { toast } from 'react-toastify'
import httpService from '../../common/http.service'

export const appHubLogin = createAsyncThunk('appHub/appHubLogin', async params => {
	//  console.log(params, "params");
	try {
		const response = await httpService.post('/auth/sendotpteam', {}, params)
		// console.log(response, "response")
		if (response.data) {
			response.data.navigate = params.navigate
		}
		return await response.data.data
	} catch (error) {
		toast.error(error?.message)
	}
})

// export const appHubLoginOtp = createAsyncThunk('appHub/appHubLoginOtp', async params => {
// 	try {
// 		const response = await httpService.post('/auth/verifyotpteam', {}, params)

// 		const userPermissions = response.data?.data.user?.permissions || []
// 		const permissionNames = userPermissions.map(permission => permission.name)

// 		localStorage.setItem('hubAdmin', JSON.stringify(response?.data?.data?.user))

// 		if (response.data.data.user.adminOfHubs && response.data.data.token) {
// 			params.navigate('/dashboard')
// 			response.data.data.navigate = params.navigate
// 		} else if (permissionNames.length > 0) {
// 			response.data.data.navigate = params.navigate
// 			params.navigate(`/${permissionNames[0]}`)
// 		} else {
// 			params.navigate('/')
// 		}

// 		return { data: response.data, navigate: params.navigate }
// 	} catch (error) {
// 		toast.error(error?.message)
// 	}
// })

export const appHubLoginOtp = createAsyncThunk('appHub/appHubLoginOtp', async params => {
	try {
		const response = await httpService.post('/auth/verifyotpteam', {}, params)

		const user = response.data?.data?.user
		const token = response.data?.data?.token

		const userPermissions = user?.permissions || []
		const permissionNames = userPermissions.map(p => p.name)

		const hubId = user?.permissionOfHub

		localStorage.setItem('hubAdmin', JSON.stringify(user))

		if (user?.adminOfHubs && token) {
			params.navigate('/dashboard')
		} else if (permissionNames.includes('community-setup') && hubId) {
			params.navigate(`/community-setup/details/${hubId}`)
		} else if (permissionNames.length > 0) {
			params.navigate(`/${permissionNames[0]}`)
		} else {
			params.navigate('/')
		}

		return { data: response.data }
	} catch (error) {
		toast.error(error?.message)
	}
})

export const appHubAdminSlice = createSlice({
	name: 'Hub',
	initialState: {
		HubAdmin: '',
		Hub: '',
		// userType: "",
	},
	reducers: {},
	extraReducers: builder => {
		builder.addMatcher(isAllOf(appHubLogin.fulfilled), (state, action) => {
			state.Hub = action.payload.data
			//  console.log(action.payload.data);
		})
		builder.addMatcher(isAllOf(appHubLoginOtp.fulfilled), (state, action) => {
			state.HubAdmin = action.payload?.data
			//  console.log(action.payload);
			//  console.log(state);
			const userPermissions = action.payload?.data?.data?.user?.permissions || []
			const permissionNames = userPermissions.map(permission => permission.name)
			//  console.log(permissionNames);
			state.userType = permissionNames
			// console.log(permissionNames);
			// console.log(state.HubAdmin);
			if (action?.payload?.data?.data?.token) {
				const token = action.payload.data.data.token
				//  console.log(token, "token");
				const user = action.payload.data.data.user || ''
				// console.log(user, "user");
				const hubId = user?.adminOfHubs || ''
				//  console.log(hubId, "hubId");
				const permissionOfHub = user?.permissionOfHub || ''
				// console.log(permissionOfHub, "permissionOfHub");
				localStorage.setItem('token', token)
				localStorage.setItem('user', JSON.stringify(user))
				localStorage.setItem('hubId', hubId)
				localStorage.setItem('permissionOfHub', permissionOfHub)
				localStorage.setItem('permissions', permissionNames.join(','))

				// if(hubId) {
				//   action.payload.navigate("/dashboard");
				//   console.log(action.payload)
				// } else {
				//   console.log(action.payload)
				//   action.payload.navigate(`/${permissionNames[0]}`);
				// }
				if (hubId) {
					action.payload.navigate('/dashboard')
					// console.log(action.payload);
				} else if (permissionNames.length > 0) {
					// console.log(action.payload);
					action.payload.navigate(`/${permissionNames[0]}`)
				} else {
					toast.error('You do not have access to this portal.')
					action.payload.navigate('/')
				}
			}
		})
	},
})

export default appHubAdminSlice.reducer
